import React from "react"
import PageHeader from "../../Elements/PageHeader";
import ProfileUserForm from "../../../forms/dashboard/user/ProfileUserForm";
import useQuery from "../../../hook/useQuery";


const ProfileUser:React.FC = () => {
    const queryParams = useQuery()

    return(
        <React.Fragment>
            <PageHeader title={"پروفایل کاربر"} isBackBtn urlBackBtn={"/dashboard/users/list"} />
            <div>
                <ProfileUserForm userId={parseInt(queryParams.get('id')!)} />
            </div>
        </React.Fragment>
    )
}

export default ProfileUser